import { useAuth } from "react-oidc-context";
import BirdieForm from "./BirdieForm";
import StandingsPage from "./Standings";
import MyBirdies from "./MyBirdies";
import MyStats from "./MyStats";
import StatsForm from "./StatsForm";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { Button, Stack, Avatar, IconButton, Menu, MenuItem, Box } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import React, { useState } from "react";

function App() {
  const auth = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleSignOut = () => {
    handleMenuClose();
    auth.removeUser();
  };

  if (auth.isLoading) {
    return <div>Loading...</div>;
  }

  if (auth.error) {
    return <div>Encountered error: {auth.error.message}</div>;
  }

  if (auth.isAuthenticated) {
    return (
      <Router>
        <Box sx={{ position: "relative" }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mt: 3, mb: 2 }}>
            <h1 style={{ marginRight: 16 }}>Big Birdie Tracker</h1>
            <IconButton onClick={handleAvatarClick} size="large">
              <Avatar>
                <AccountCircleIcon />
              </Avatar>
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MenuItem onClick={handleSignOut}>Sign out</MenuItem>
            </Menu>
          </Box>
          <nav>
            <Stack direction="row" spacing={2} sx={{ mb: 2, justifyContent: "center", flexWrap: "wrap" }}>
              <Button component={Link} to="/" variant="contained" color="success" >
                Standings
              </Button>
              <Button component={Link} to="/my-birdies" variant="contained" color="secondary" >
                My Birdies
              </Button>
              <Button component={Link} to="/my-stats" variant="contained" color="primary" >
                My Stats
              </Button>
            </Stack>
          </nav>
          <Routes>
            <Route path="/" element={<StandingsPage />} />
            <Route path="/my-birdies" element={<MyBirdies />}>
              <Route path="input" element={<BirdieForm />} />
            </Route>
            <Route path="/my-stats" element={<MyStats />}>
              <Route path="input" element={<StatsForm />} />
            </Route>
          </Routes>
        </Box>
      </Router>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "4rem" }}>
      <h1>Big Birdie Tracker</h1>
      <Button
        variant="contained"
        color="primary"
        size="large"
        onClick={() => auth.signinRedirect()}
        sx={{ fontWeight: 700 }}
      >
        Sign in
      </Button>
    </div>
  );
}

export default App;